<template>
    <div class="row" v-if="isValid('CanViewBrand')">
        <div class="col-lg-12 col-sm-12 ml-auto mr-auto" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
            
            <div class="card">
                <div class="BorderBottom ml-2 mr-2 mt-3 mb-3">
                    <span class=" DayHeading">{{ $t('brand.ProductBrandList') }}</span>
                </div>
                <div class="card-body">
                    <div class="row" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <div class="form-group">
                                <label>{{ $t('brand.SearchbyBrand') }}</label>
                                <div>
                                    <input type="text" class="form-control search_input" v-model="search" name="search" id="search" :placeholder="$t('brand.Search')" />
                                    <span class="fas fa-search search_icon"></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">
                            <a v-if="isValid('CanAddBrand')" href="javascript:void(0)" class="btn btn-primary " style="margin-top:27px;" v-on:click="openmodel"><i class="fa fa-plus"></i> {{ $t('brand.AddNew') }} </a>
                            <router-link :to="'/ProductManagement'">
                                <a href="javascript:void(0)" class="btn btn-outline-danger " style="margin-top:27px;">  <i class="fas fa-arrow-circle-left fa-lg"></i> </a>
                            </router-link>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">

                            <table class="table table-striped table-hover table_list_bg" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                <thead v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                    <tr>
                                        <th>#</th>
                                        <th>
                                            {{ $t('brand.Code') }}
                                        </th>
                                        <th v-if="english=='true'">
                                            {{ $t('brand.BrandName') |englishLanguage}}
                                        </th>
                                        <th v-if="isOtherLang()" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                            {{ $t('brand.BrandNameArabic') |arabicLanguage}}
                                        </th>
                                        <th class="text-center" width="40%">
                                            {{ $t('brand.Description') }}
                                        </th>
                                        <th>
                                            {{ $t('brand.Status') }}
                                        </th>


                                    </tr>
                                </thead>
                                <tbody v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">
                                    <tr v-for="(brand,index) in brandlist" v-bind:key="brand.id">
                                        <td v-if="currentPage === 1">
                                            {{index+1}}
                                        </td>
                                        <td v-else>
                                            {{((currentPage*10)-10) +(index+1)}}
                                        </td>

                                        <td v-if="isValid('CanEditBrand')">
                                            <strong>
                                                <a href="javascript:void(0)" v-on:click="EditBrand(brand.id)">{{brand.code}}</a>
                                            </strong>
                                        </td>
                                        <td v-else>

                                            {{brand.code}}

                                        </td>
                                        <td v-if="english=='true'">
                                            {{brand.name}}
                                        </td>
                                        <td v-if="isOtherLang()">
                                            {{brand.nameArabic}}
                                        </td>


                                        <td class="text-center">
                                            {{brand.description}}
                                        </td>
                                        <td>{{brand.isActive==true?$t('brand.Active'):$t('brand.De-Active')}}</td>


                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                    <div class="float-left">
                        <span v-if="currentPage===1 && rowCount === 0">  {{ $t('brand.ShowingEntries') }}</span>
                        <span v-else-if="currentPage===1 && rowCount < 10">  {{ $t('brand.Showing') }} {{currentPage}}  {{ $t('brand.to') }} {{rowCount}}  {{ $t('brand.of') }} {{rowCount}}  {{ $t('brand.entries') }}</span>
                        <span v-else-if="currentPage===1 && rowCount >= 11  "> {{ $t('brand.Showing') }} {{currentPage}} {{ $t('brand.to') }} {{currentPage*10}} {{ $t('brand.of') }} {{rowCount}} {{ $t('brand.entries') }}</span>
                        <span v-else-if="currentPage===1"> {{ $t('brand.Showing') }} {{currentPage}} {{ $t('brand.to') }} {{currentPage*10}} of {{rowCount}} {{ $t('brand.entries') }}</span>
                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> {{ $t('brand.Showing') }} {{(currentPage*10)-9}} {{ $t('brand.to') }} {{currentPage*10}} {{ $t('brand.of') }} {{rowCount}} {{ $t('brand.entries') }}</span>
                        <span v-else-if="currentPage === pageCount"> {{ $t('brand.Showing') }} {{(currentPage*10)-9}} {{ $t('brand.to') }} {{rowCount}} {{ $t('brand.of') }} {{rowCount}} {{ $t('brand.entries') }}</span>
                    </div>
                    <div class="float-right">
                        <div class="overflow-auto" v-on:click="GetBrandData()">
                            <b-pagination pills size="lg" v-model="currentPage"
                                          :total-rows="rowCount"
                                          :per-page="10"
                                          first-text="First"
                                          prev-text="Previous"
                                          next-text="Next"
                                          last-text="Last"></b-pagination>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <brandmodel :brand="newBrand"
                    :show="show"
                    v-if="show"
                    @close="IsSave"
                    :type="type" />

    </div>
    <div v-else> <acessdenied></acessdenied></div>
</template>


<script>
    import clickMixin from '@/Mixins/clickMixin'
    export default {
        mixins: [clickMixin],
        data: function () {
            return {
                searchQuery: '',
                show: false,
                brandlist: [],
                newBrand: {
                    id: '',
                    name: '',
                    nameArabic: '',
                    description: '',
                    code: '',
                    isActive: true
                },
                type: '',
                search: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                arabic: '',
                english: '',
            }
        },
        watch: {
            search: function (val) {
                this.GetBrandData(val, 1);
            }
        },
        methods: {
            IsSave: function () {
                
                this.show = false;

                this.GetBrandData(this.search, this.currentPage);
            },
            getPage: function () {
                this.GetBrandData(this.search, this.currentPage);
            },
            openmodel: function () {
                this.newBrand = {
                    id: '00000000-0000-0000-0000-000000000000',
                    name: '',
                    nameArabic: '',
                    description: '',
                    isActive: true

                }
                this.show = !this.show;
                this.type = "Add";
            },
            GetBrandData: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('Product/BrandList?isActive=false' + '&pageNumber=' + this.currentPage + '&searchTerm=' + this.search, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.brandlist = response.data.results.brands;
                        root.pageCount = response.data.pageCount;
                        root.rowCount = response.data.rowCount;
                        root.loading = false;
                    }
                    root.loading = false;
                });
            },
            EditBrand: function (Id) {

                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Product/BrandDetail?Id=' + Id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data) {
                            root.newBrand.id = response.data.id;
                            root.newBrand.name = response.data.name;
                            root.newBrand.nameArabic = response.data.nameArabic;
                            root.newBrand.description = response.data.description;
                            root.newBrand.code = response.data.code;
                            root.newBrand.isActive = response.data.isActive;
                            root.show = !root.show;
                            root.type = "Edit"
                        } else {
                            console.log("error: something wrong from db.");
                        }
                    },
                        function (error) {
                            this.loading = false;
                            console.log(error);
                        });

            }
        },
        created: function () {
            this.$emit('input', this.$route.name);
        },
        mounted: function () {
            this.english = localStorage.getItem('English');
            this.arabic = localStorage.getItem('Arabic');
            this.GetBrandData(this.search, 1);

        }
    }
</script>